const Styles = {
    'layout': 'TwoColumnOverlayMapLayout_layout--bc651d3e',
    'sidebarRight': 'TwoColumnOverlayMapLayout_sidebarRight--b8d43aa0',
    'sidebar': 'TwoColumnOverlayMapLayout_sidebar--475d7ad7',
    'sidebarInner': 'TwoColumnOverlayMapLayout_sidebarInner--d784d31a',
    'overlay': 'TwoColumnOverlayMapLayout_overlay--97366935',
    'open': 'TwoColumnOverlayMapLayout_open--5a24788d',
    'overlayInner': 'TwoColumnOverlayMapLayout_overlayInner--b0cc2869',
    'closed': 'TwoColumnOverlayMapLayout_closed--6411204f',
    'loading': 'TwoColumnOverlayMapLayout_loading--f8271fb4',
    'map': 'TwoColumnOverlayMapLayout_map--8d72fe34'
};

export default Styles;